import { UserContext, UserStatus, UserTypes } from '@contexts/Shared';

import { useRouter } from 'next/router';
import React, { useContext, useEffect } from 'react';

type UseUserProps = {
  redirectTo: string;
  redirectIfFound?: boolean;
  referrer?: string;
  requiredRole?: UserTypes;
};

const useUser = ({
  redirectTo,
  redirectIfFound = false,
  referrer,
  requiredRole,
}: UseUserProps) => {
  const user = useContext(UserContext);
  const router = useRouter();

  const sendToLogin = React.useCallback(() => {
    const searchParams = new URLSearchParams();

    if (referrer) {
      searchParams.set('referrer', referrer);
    }
    if (requiredRole) {
      searchParams.set('rol', requiredRole);
    }

    router.push(`${redirectTo}?${searchParams.toString()}`);
  }, []);

  useEffect(() => {
    if (!redirectTo || !user) return;

    const isLoggedIn = user.data && user.status == UserStatus.IS_LOGGED_IN;
    const isNotLoggedIn = user.status == UserStatus.IS_NOT_LOGGED;

    const matchRequiredRole =
      !requiredRole || requiredRole === user?.data?.role;

    if (isNotLoggedIn || (isLoggedIn && !matchRequiredRole)) {
      sendToLogin();
    }
  }, [user?.status]);

  return { user };
};

export { useUser };
